import { MemberOption, UserMapValue } from '../models/User';

// Raw API response types
export interface RawUserApiResponse {
  displayName: string;
  email: string;
  id: string;
}

export interface RawAgentApiResponse {
  uid: string;
  name: string;
  baseModel: string;
  description: string;
  avatarUrl: string | null;
  isActive: boolean;
}

// Transform user API response to internal format
export function transformUser(raw: RawUserApiResponse): MemberOption {
  return {
    name: raw.displayName,
    email: raw.email,
    uid: raw.id,
    id: raw.id,
    userType: 'user',
  };
}

// Transform agent API response to internal format
export function transformAgent(raw: RawAgentApiResponse): MemberOption {
  return {
    name: raw.name,
    email: '',
    uid: raw.uid,
    id: raw.uid,
    userType: 'agent',
    description: raw.description,
    baseModel: raw.baseModel ?? '',
    avatarUrl: raw.avatarUrl,
    isActive: raw.isActive,
  };
}

// Build lookup map from members array
export function buildUsersMap(members: MemberOption[]): Record<string, UserMapValue> {
  const map: Record<string, UserMapValue> = {};
  members.forEach((m) => {
    map[m.uid.toLowerCase()] = {
      name: m.name,
      email: m.email,
      userType: m.userType,
      avatarUrl: m.avatarUrl,
    };
  });
  return map;
}
